import AlurPeminjamanIndividu from "../../../../assets/img/product/flow-pinjaman.svg";
import AlurPeminjamanProduktif from "../../../../assets/img/product/alur-peminjaman-produktif.svg";
import AlurPeminjamanTextIndividu from "./AlurPeminjamanTextIndividu";
import React from "react";
import AlurPeminjamanTextProduktif from "./AlurPeminjamanTextProduktif";

export default function AlurPeminjaman({type}){
    return(
        type === 'individu' ?
            <div className='container-alur'>
                <h2 className="text-header">Alur Peminjaman Melalui <span>Danai.id</span></h2>
                <img src={AlurPeminjamanIndividu} alt='alurPeminjaman'></img>
                <AlurPeminjamanTextIndividu/>
            </div>
            :
            <div className='container-alur'>
                <h2 className="text-header">Alur Peminjaman Melalui <span>Danai.id</span></h2>
                <img src={AlurPeminjamanProduktif} alt='alurPeminjaman'></img>
                <AlurPeminjamanTextProduktif/>
            </div>
    );
}